

export const DEFAULT_MESSAGE = "You don't have any entries at the moment!";
